import {
  TextField,
  InputLabel,
  Select,
  Checkbox,
  FormControlLabel,
  Radio,
  FormControl,
  Typography,
} from '@mui/material'
import { withStyles } from '@mui/styles'
import UIIcons from '../../assets/ui-icons'

export const CustomInputLabel = withStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    fontSize: 14,
  },
}))(InputLabel)

const CollapsedRoot = withStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 6,
    flexWrap: 'wrap',
    marginTop: theme.spacing(2),
    fontSize: 14,
  },
}))(Typography)

const CollapsedLabel = withStyles(theme => ({
  root: {
    fontSize: 14,
    color: theme.palette.text.secondary,
  },
}))(Typography)

const CollapsedValueText = withStyles(theme => ({
  root: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
  },
}))(Typography)

// Rendered in place of a select that has only one option to choose from:
// there is nothing to pick, so the value is shown inline as "Label: value".
export const CollapsedField = ({ label, value, ...props }) => (
  <CollapsedRoot component="div" {...props}>
    <CollapsedLabel component="span">{label}:</CollapsedLabel>
    <CollapsedValueText component="span">{value}</CollapsedValueText>
  </CollapsedRoot>
)

export const StyledTextField = withStyles(theme => ({}))(TextField)

const defaultTextFieldProps = {
  variant: 'outlined',
  margin: 'dense',
  size: 'small',
  fullWidth: true,
}

export const CustomTextField = props => {
  return <StyledTextField {...defaultTextFieldProps} {...props} />
}

export const CustomSelect = withStyles(theme => ({
  root: {
    height: 'auto',
  },
  select: {
    '&:focus': {
      backgroundColor: theme.palette.common.white,
    },
  },
}))(Select)

const StyledCheckbox = withStyles(theme => ({
  root: {
    '&:hover': {
      color: '#1C71AD',
    },
    '&.Mui-disabled svg': {
      color: '#CCCCCC',
      fill: '#CCCCCC',
    },
    '&.Mui-disabled svg path': {
      fill: '#CCCCCC',
    },
    margin: 5,
    padding: 5,
  },
  checked: {},
}))(Checkbox)

export const CustomCheckbox = props => {
  return (
    <StyledCheckbox
      icon={<UIIcons.CheckboxUncheckedIcon />}
      checkedIcon={<UIIcons.CheckboxCheckedIcon />}
      {...props}
    />
  )
}

const StyledRadioButton = withStyles(theme => ({
  root: {
    '&:hover': {
      color: '#1C71AD',
    },
    margin: 5,
    padding: 5,
  },
  checked: {},
}))(Radio)

export const CustomRadioButton = props => {
  return (
    <StyledRadioButton
      icon={<UIIcons.RadioButtonUncheckedIcon />}
      checkedIcon={<UIIcons.RadioButtonCheckedIcon />}
      {...props}
    />
  )
}

export const CustomFormControlLabel = withStyles(theme => ({
  root: {
    fontSize: 14,
  },
}))(FormControlLabel)

export const CustomFormControl = withStyles(theme => ({
  root: {
    '&>div': {
      height: 'auto',
    },
  },
}))(FormControl)

export const textFieldNoArrowStyles = {
  '-webkit-appearance': 'none',
  /* Chrome, Safari, Edge, Opera */
  '&::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  '&::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  /* Firefox */
  '&[type=number]': {
    '-moz-appearance': 'textfield',
  },
}
